import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-heading',
  standalone: true,
  imports: [],
  templateUrl: './heading.component.html',
  styleUrl: './heading.component.scss',
})
export class HeadingComponent {
  @Input() heading: string = 'Heading';
  @Input() fontSize: '1rem' | '1.25rem' | '1.5rem' = '1.25rem';
  @Input() subHeading: string = 'Sub Heading';
  @Input() subHeadingfontSize: '1rem' | '1.25rem' | '1.5rem' = '1.25rem';
}
